import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
// import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from '../../utils/API/requestMiddleware';
// import { encryptUrlData } from '../../services/CryptoService';

const databaseHealthAPI = createApi({
    baseQuery: defautBaseQuery, // Replace with your API endpoint
    reducerPath: 'databaseHealthAPI',
    endpoints: (builder) => ({
        addDatabaseHealthWizard: builder.mutation({
            query: (details) => ({
                url: '/DatabaseHealth/AddDatabaseHealthWizard',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        updateDatabaseHealthWizard: builder.mutation({
            query: (details) => ({
                url: '/DatabaseHealth/UpdateDatabaseHealthWizard',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getDatabaseHealthWizardList: builder.query({
            query: () => ({
                url: '/DatabaseHealth/GetDatabaseHealthWizardList',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getDatabaseHealthWizardOutput: builder.query({
            query: (id) => ({
                url: `/DatabaseHealth/GetDatabaseHealthWizardOutput/?databaseHealthId=${id}`,
                method: 'GET',
                // body: transformRequest(id)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        exportDatabaseHealthWizardOutput: builder.query({
            query: (id) => ({
                url: `/DatabaseHealth/ExportDatabaseHealthWizardOutput/?databaseHealthId=${id}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
                // body: transformRequest(id)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteDatabaseHealthWizard: builder.mutation({
            query: (id) => ({
                url: `/DatabaseHealth/DeleteDatabaseHealthWizard`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
});

export const {
    useAddDatabaseHealthWizardMutation,
    useUpdateDatabaseHealthWizardMutation,
    useLazyGetDatabaseHealthWizardListQuery,
    useLazyGetDatabaseHealthWizardOutputQuery,
    useLazyExportDatabaseHealthWizardOutputQuery,
    useDeleteDatabaseHealthWizardMutation
} = databaseHealthAPI;

export default databaseHealthAPI;